import {CircularProgress, Collapse, Link, Typography} from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import EducationHistoryFields from "../acordionFields/EducationHistoryFields";
const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const EducationSection = (props) => {
  const classes = useStyles();
  const {educationHistory, handleTabChange, statusRelationships,handleNestedFieldChange,tab, handleRemoveNestedFields, handleAddNestedFields} = props;

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 1)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 1 ? classes.tabActive : ''}`}>Education</Typography>
        {statusRelationships === 'start' ? <CircularProgress /> : ''}
        {tab === 1 ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === 1}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            {educationHistory.map((props) => <EducationHistoryFields key={props.id} education={props} onChange={handleNestedFieldChange} onClick={handleRemoveNestedFields} />)}

            <Link to='' className={classes.addNewRelationshipLink} onClick={(event) => handleAddNestedFields('education', 'educationHistory')}>+ New Education Fields</Link>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default EducationSection;